import { BrandColors } from '../theme';

export const datatableTokens = {
    root: {
        borderColor: BrandColors.semantic.border,
    },
    header: {
        background: BrandColors.surface[50],
        borderColor: BrandColors.semantic.border,
        color: BrandColors.surface[700],
        borderWidth: '0 0 1px 0',
        padding: '0.75rem 1rem',
    },
    headerCell: {
        background: BrandColors.surface[50],
        hoverBackground: BrandColors.primary[100],
        selectedBackground: BrandColors.primary[100],
        borderColor: BrandColors.semantic.border,
        color: BrandColors.surface[600],
    },
};
